module.exports = {"physical":"","holy":"","fire":"","nature":"","frost":"","shadow":"","arcane":""};